import React, { Component } from 'react'
import { Badge } from 'react-bootstrap';

class RetencionCancelacionStatus extends Component {

  get config() {
    const { status } = this.props;

    let variant = 'secondary';
    let icon = 'check';;
    let text = '';

    switch (status) {
      case 10:
          variant = 'secondary';
          icon = 'clock';
          text = 'En Proceso';
        break;

      case -1:
          variant = 'secondary';
          icon = 'check';
          text = 'Rechazado';
        break;
      case undefined:
          variant = 'info';
          icon = 'clock';
          text = '...';
        break;

      default:
        break;
    }

    return {
      icon,
      variant,
      text
    }
  }

  render() {
    const { variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        { text }
      </Badge>
    )
  }
}

export default RetencionCancelacionStatus;